import React from 'react'
import { Box, Paper, Divider, Typography, makeStyles } from '@material-ui/core'
import { FieldArray } from 'react-final-form-arrays'
import useWebService from '../../../../services/web/useWebService'
import useAuthenStore from '../../../../stores/authen/authenStore'
import AgendaCard from './AgendaCard'
import { ProjectRequest } from '../agendaTypes'
import useTranslate from '../../../../i18n/useTranslate'

const MeetingMinuteForm: React.FC<{ prefix?: string; canEdit?: boolean }> = ({
    prefix = 'agendaItems',
    canEdit = true,
}) => {
    const classes = useStyles()
    const t = useTranslate()
    const { searchTbl: searchTblApi } = useWebService()
    const profile = useAuthenStore()?.profile

    const searchProjects = React.useCallback(
        (payload: ProjectRequest) =>
            searchTblApi(
                {
                    ...payload,
                    userId: profile?.userId ?? payload.userId,
                },
                profile.userGroupId + '',
            ),
        [searchTblApi, profile?.userId],
    )

    return (
        <Paper className={classes.root} elevation={0}>
            <Box className={classes.headerBar}>
                <Typography variant="h6" style={{ fontWeight: 700 }}>
                    {t.get('UM.SETTING_AGENDA.TAB.MINUTES')}
                </Typography>
            </Box>

            <Divider />

            <Box className={classes.section}>
                <FieldArray name={`${prefix}.agendas`}>
                    {({ fields }) => {
                        return (
                            <>
                                {fields.map((pfx: string, idx: number) => (
                                    <AgendaCard
                                        key={pfx}
                                        idx={idx}
                                        namePrefix={pfx}
                                        onRemove={() => fields.remove(idx)}
                                        searchTbl={searchProjects}
                                        canEdit={canEdit}
                                    />
                                ))}
                            </>
                        )
                    }}
                </FieldArray>
            </Box>
        </Paper>
    )
}

const useStyles = makeStyles((theme) => ({
    root: { borderRadius: 12, border: '1px solid #E5E7EB', background: '#fff' },
    headerBar: {
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        fontWeight: 700,
    },
    section: { padding: theme.spacing(3), display: 'flex', flexDirection: 'column', gap: 16 },
}))

export default MeetingMinuteForm
